// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","formButtons":"_1LpHf_BNHT3jk2PogjqHGl","alignRight":"_2cP5LPFLNVXeZnA8Z1a7CY","errors":"_2NbpaoLV_Nlr1BKO-Wp7fa"};